import { createColumnDatetime, createColumnInput } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.user.username"), dataIndex: "username", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.user.firstNameTh"), dataIndex: "first_name_th", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.user.lastNameTh"), dataIndex: "last_name_th", align: "center" }),
        // createColumnInput({ title: () => i18n.global.t("views.report.name"), dataIndex: "full_name", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.name"),
            dataIndex: "full_name",
            dataIndexValue: ({ record }) => (record.key === "1" ? record.company_name_th : record.full_name_th),
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.user.refDepartment"), dataIndex: "ref_department_name_th", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.user.refJobPosition"), dataIndex: "ref_job_position_name_th", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.user.refPersonType"), dataIndex: "value", align: "center" }),
        createColumnDatetime({ title: () => i18n.global.t("views.report.datetime"), dataIndex: "datetime", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("views.report.ip"), dataIndex: "ip", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("views.report.edit"), dataIndex: "menu_name", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.result"),
            dataIndexValue: () => "สำเร็จ",
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
